import { IconButton, Stack, Badge, Popover, Box, TextField, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import apiCNP from "../services/apiCNP";


export default function ProvinciaFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [provincias, setProvincias] = useState([]);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    apiCNP.get('/provincias')
      .then(res => {
        setProvincias(res?.data?.provincias);
      }).catch(err => console.error(err));

  }, []);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.provincia}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
          <TextField
            type="text"
            label="Provincia"
            select
            style={{ width: 200 }}
            size="small"
            name="provincia"
            variant="outlined"
            onChange={(e) =>
              props.setProvincia(e.target.value === "Provincias" ? "" : e.target.value)
            }
            value={props.provincia}
          >
            <MenuItem value="Provincias">Provincias</MenuItem>
            {provincias?.map((provincia) => (
              <MenuItem key={provincia._id} value={provincia?.designacao} >
                {provincia.designacao}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Popover>
    </Stack>
  );
};


